import { createReducer, on } from '@ngrx/store';

import * as TrackerActions from './tracker.actions';
import * as TrackerFeatureState from './tracker.state';

export const reducer = createReducer(
  TrackerFeatureState.initialTrackerState,

  on(TrackerActions.updateVideoUsage, (state, { videoUsage }) => {
    return { ...state, videoUsage: { ...videoUsage } };
  }),

  on(TrackerActions.saveVideoUsage, (state) => {
    return { ...state, hasLoaded: true };
  }),

  on(TrackerActions.saveVideoUsageSuccess, (state) => {
    return { ...state, videoUsage: null, hasLoaded: false };
  }),

  on(TrackerActions.startInterestsTrackingSuccess, (state, { tracker }) => {
    return { ...state, interestSurveyTracker: tracker };
  })
);
